import { useState, useEffect } from 'react';
import { RedriveRequestItem } from '../../../types/common';
import { RedriveApiFactory } from '../../../lusca-search-api/LuscaSearchApiFactory';
import { Stage } from '../../../lusca-search-api/generated-src';

export const useRedriveData = (selectedStage: Stage) => {
  const [pastRedrives, setPastRedrives] = useState<RedriveRequestItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const fetchRedrives = async () => {
      try {
        setLoading(true);
        setError("");

        const redriveApi = RedriveApiFactory();
        const response = await redriveApi.getRedriveInfo(selectedStage);

        if (response.data && response.data.executions) {
          const formattedRedrives = response.data.executions.map(execution => ({
            executionId: execution?.executionId,
            stage: execution?.stage,
            orderCount: execution?.orders ? execution.orders.toString() : "",
            status: execution?.status ? execution.status : "",
            executor: execution.executor,
            executionDate: new Date(
              execution?.timestamp ? execution.timestamp * 1000 : 0
            ).toISOString(),
          } as RedriveRequestItem));

          setPastRedrives(formattedRedrives);
        } else {
          setPastRedrives([]);
        }
      } catch (error) {
        console.error("Error fetching redrives:", error);
        setError("Failed to load redrive history");
        setPastRedrives([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedStage) {
      fetchRedrives();
    }
  }, [selectedStage]);

  return { pastRedrives, loading, error };
};
